var forgotUidCtrl = function (restSvc, ifacsSvc, $location, loginLocation, $analytics,noCAPTCHA,$window,$scope) {
    "use strict";

    this.restSvc = restSvc;
    this.ifacsSvc = ifacsSvc;
    this.location = $location;
    this.loginLocation = loginLocation;
    this.analytics = $analytics;
    this.scope = $scope;
    this.window = $window;
    this.showCaptcha = !(/MSIE [1-8]\./.test(this.window.navigator.userAgent));
    this.repCode=false;
    this.isRecapSolved = false;

    this.onLoad();
};


forgotUidCtrl.prototype.onLoad = function () {
    "use strict";

    this.onUsernameEmailChange();

    var clientCd = this.loginLocation.clientCd();
    var rest = this.restSvc.query({type: "configuration", method: "retrieveForgotUidSetting"}, {"clientCd" : clientCd});
    rest.$promise.then(this.pass(this),this.fail);
};

forgotUidCtrl.prototype.pass = function (controller){
    "use strict";
    return function (result) {
        controller.userAdminSettingMap = result.userAdminSettingMap;
    };

};

forgotUidCtrl.prototype.onSubmit = function () {
    "use strict";

    // track analytics
    this.analytics.eventTrack("ForgotUID",
        {
            "emailValue": this.email,
            "emailText": this.email,
            "emailFieldName": "email",
            "emailObjectName": "ForgotUidSetting",
            "emailModule": "ForgotUidSetting",
            "submodule": "ForgotUidSetting",
            "module": "Prelogin"
        }
    );

    this.isForgotUidSubmitted = true;
    this.isForgotUidCaptchaResponseOk = false;
    this.isForgotUidResponseSuccess=false;
    this.isForgotUidResponsefail=false;
    this.isForgotUidCaptchaTicked=false;
    
    var langCd = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
    langCd = langCd.substr(0,2);
    
    var userResponse=document.getElementById("userResponse").value;
    var userResponse_prev=document.getElementById("userResponse_prev").value;
    
    //console.log("userResponse :"+userResponse);
    //console.log("userResponse_prev :"+userResponse_prev);
    
    if(userResponse_prev == userResponse){
    	//this.isForgotUidSubmitted = true;
    	this.isForgotUidCaptchaTicked=true;
    	this.disableSubmit = false;
        return false;
    }
    
   // console.log("userResponse length :"+userResponse.trim().length);
    if (0 == userResponse.trim().length) {
    	//this.isForgotUidSubmitted = true;
    	this.isForgotUidCaptchaTicked=true;
    	this.disableSubmit = false;
        return false;
    }

    document.getElementById("userResponse_prev").value=userResponse;
    this.disableSubmit = true;
   // this.isForgotUidSubmitted = true;
   // this.waitingForResponse=true;
    
    this.ifacsSvc.forgotUid({ method:"forgot_uid"},
        {language: langCd, email : this.email, recaptchaUserResponse : document.getElementById("userResponse").value})
        .$promise.then(this.success(this));
  };

   forgotUidCtrl.prototype.success = function (controller) {
    "use strict";
   
    window.console.log("Forgot username request is submitted.");

    return function(response) {
    	
        var responseCode = response.code;
        window.console.log("Response from ifacs:" + responseCode);
       // controller.isForgotUidSubmitted = true;
        controller.isForgotUidCaptchaTicked=false;
       // controller.waitingForResponse=false;
        
        if ("SUCCESS" === responseCode) {
            controller.isForgotUidResponseSuccess = true;           
        }else if ("RECAPTCHAFAIL" === responseCode) {
        	grecaptcha.reset();
        	controller.disableSubmit = false;
            controller.isForgotUidCaptchaResponseOk = true;
        } else {
        	grecaptcha.reset();
        	controller.disableSubmit = false;
            controller.isForgotUidResponsefail = true;
        }
    };
   
  };
  
	 forgotUidCtrl.prototype.onCancel = function () {
	    "use strict";
        var url=window.location.href;
        var ifstwbprinUrlIndex=url.indexOf('ifastweb');  
        var secondPart,firstPart,redirectUrl;
        if(ifstwbprinUrlIndex > 0){
            secondPart= "ifastweb/login.html#!/login";
            firstPart= url.substring(0,url.indexOf("ifastweb"));
            redirectUrl=firstPart+secondPart;
            window.location.href=redirectUrl
        }else{
            secondPart= "/login.html#!/login";
            firstPart= url.substring(0,url.indexOf("/login.html"));
            redirectUrl=firstPart+secondPart;
            window.location.href=redirectUrl
  }
};

	forgotUidCtrl.prototype.onUsernameEmailChange = function () {
	    "use strict";
	
	    if (null !== this.email && undefined !== this.email && 0 < this.email.trim().length) {
	        this.disableSubmit = false;
	    } else {
	        this.disableSubmit = true;
	    }
	};
	
	forgotUidCtrl.prototype.setValid = function (status){
		 this.repCode=status;	
	}
	
	forgotUidCtrl.$inject = ["restSvc", "ifacsSvc", "$location", "loginLocation", "$analytics","noCAPTCHA","$window"];
	angular.module("iFAST.login")
	    .controller("forgotUidCtrl", forgotUidCtrl).config(["noCAPTCHAProvider", function (noCaptchaProvider) {
	        "use strict";
	        noCaptchaProvider.setSiteKey("6LdSzf4SAAAAAP8IbU-e3uu3HvkZHsY9X7-mmT5J");
	        noCaptchaProvider.setTheme("dark");

    }]);


// WEBPACK FOOTER //
// ./WebContent/src/login/forgotUid-controller.js